exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SkeletonVcDemo h4[data-v-52efd2be]{color:#066}.SkeletonVcDemo .demoItem[data-v-52efd2be]{padding:5px 0;font-size:18px;border-bottom:1px dotted #999}.SkeletonVcDemo .person[data-v-52efd2be]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:10px}.SkeletonVcDemo .person .photo[data-v-52efd2be]{width:80px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.SkeletonVcDemo .person .article[data-v-52efd2be]{display:inline-block;line-height:20px;text-indent:50px;margin-left:20px}", ""]);

// exports
